import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BadgeComponent',
    props: {
        variant: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["badge", ['text-bg-' + (__props.variant ?? 'default'), 'badge--' + (__props.variant ?? 'default')]])
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
